var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.526,
    height: 21.525,
    viewBox: "0 0 21.526 21.525",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "search",
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M21.263,20l-6.121-6.121a8.537,8.537,0,1,0-1.268,1.268l6.121,6.121A.9.9,0,1,0,21.263,20ZM8.52,15.25a6.727,6.727,0,1,1,6.727-6.727A6.734,6.734,0,0,1,8.52,15.25Z",
    transform: "translate(0 -0.004)",
    fill: "#2d335d"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.af9fa91bfc905a128b9a1bcd59ca355f.svg";
export { ForwardRef as ReactComponent };